import './main.css'
import './sms-code-style.less'

import { getQueryObject } from '@utils/index'
import $ from 'zepto-webpack'
import getIp from '@utils/getIp'
import toast from '@utils/toast'
import { sendEvent } from '@utils/track'
import { countryCode, countryText } from '@utils/constant'
import LazyLoad from 'vanilla-lazyload'
import _api from '@utils/_api'

window.jQuery = $

const extranetApiUrl = process.env.BUILD_TYPE === 'prod' ? process.env.AIR_GATAWAY : 'https://air-class-gateway-fat-alhz.zmaxis.com'
const newGateWay = process.env.BUILD_TYPE === 'prod' ? 'https://ac-operation-gateway.air-class.com' : 'https://ac-operation-gateway-fat-alhz.inzm.com'
function gtag_report_conversion(url) {
  const callback = function () {
    if (typeof url !== 'undefined') {
      window.location = url
    }
  }
  window.gtag && window.gtag('event', 'conversion', { send_to: 'AW-396168788/3rW2CImf_OICENSc9LwB' })
  window.gtag && window.gtag('event', 'conversion', { send_to: 'AW-327843671/x22XCNyp-N4CENf-qZwB', event_callback: callback })
  window.gtag && window.gtag('event', 'conversion', { send_to: 'AW-10792191965/Gqs0CPmR9vwCEN2Pj5oo' })
  return false
}

$(function () {
  // 参数
  const { channel_code = '', channel_keyword = '', email_show = 0, irclickid: clickId, media_partner = '', awc = '', sms_code_show = 0, across_click_id = '' } = getQueryObject()
  const fetchId = 21
  const languageId = 2
  // 表单后一个模块
  const slideOffset = $('.appraisal-block_2c8b').offset()
  const $fixedFooterEle = $('.footer')
  const emailVision = Number(email_show)
  const smsCodeVision = Number(sms_code_show)
  const phoneRules = /^[0-9]{3,20}$/
  if (!emailVision) $('.form-control_email').css('display', 'none')
  if (!smsCodeVision) $('.sms-code-wrap').css('display', 'none')
  let ipInfo = null

  // function awinTrack(appointmentId) {
  //   if (!appointmentId || !awc) return;
  //   const img = new Image(0, 0);
  //   const merchant = 25266;
  //   img.src = `https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=${merchant}&amount=1.00&cr=GBP&ref=${appointmentId}&parts=DEFAULT:1.00&vc=&ch=aw&testmode=0`;

  //   var AWIN = {};
  //   AWIN.Tracking = {};
  //   AWIN.Tracking.Sale = {};
  //   AWIN.Tracking.Sale.amount = '1.00';
  //   AWIN.Tracking.Sale.orderRef = appointmentId;
  //   AWIN.Tracking.Sale.parts = 'DEFAULT:1.00';
  //   AWIN.Tracking.Sale.currency = 'GBP';
  //   AWIN.Tracking.Sale.test = '0';
  //   AWIN.Tracking.Sale.channel = 'aw';
  // }

  // 进入页面埋点
  sendEvent({
    eventId: 'en_Universal_PageView',
    eventParam: {
      channel_code,
      channel_keyword,
      nation: ''
    }
  })

  // 图片懒加载
  new LazyLoad({
    elements_selector: '.lazy',
    threshold: 0
  })

  const dictCache = {
    gradeList: null,
    subjectList: null
  }
  // 表单
  const submitFormData = {
    firstName: '',
    lastName: '',
    gradeCode: '',
    age: '',
    subjectCode: '',
    mobile: '',
    email: '',
    checked: false,
    smsCode: ''
  }
  function getDictInfo() {
    _api({
      url: `${newGateWay}/air/landing/page/dict/UK/2`
    })
      .then((res) => {
        if (Array.isArray(res) && res.length) {
          submitFormData.gradeCode = res[0].gradeCode
          dictCache.subjectList = res.subjectList
          const subjectStr = handleSubjectTemplate(res[0].subjectList)
          $('select[name=subjectCode]').html(subjectStr)
        }
      })
  }
  getDictInfo()

  function renderAgeOpt(data) {
    const str = data.reduce((pre, cur) => {
      pre += `<option value="${cur.ageInfo}">${cur.ageInfo}</option>`
      return pre
    }, '<option value="" disabled selected></option>')
    $('.grade-select_1YXl').html(str)
  }
  function getAgeData() {
    _api({
      url: `${newGateWay}/air/landing/page/age/UK`
    }).then(res => {
      if (Array.isArray(res)) renderAgeOpt(res)
    })
  }
  getAgeData()

  // 设置地域 select
  const countryCodeArr = Object.keys(countryText).reduce((pre, next) => {
    pre[next] = {
      text: countryText[next],
      code: Object.keys(countryCode).find((key) => countryCode[key].find((code) => code === next)) || ''
    }
    return pre
  }, {})
  $('select[name=areaCode]').html(handleAreaTemplate(countryCodeArr))

  // 获取当前地域信息
  getIp()
    .then((res) => {
      if (res && res.countryId) {
        ipInfo = res
        const areaCode = Object.keys(countryCode).find((key) => countryCode[key].find((code) => code === res.countryId)) || '44'
        $('select[name=areaCode]').val(areaCode)
        $('.code-txt_1f_F').html('+' + areaCode)
      } else {
        $('select[name=areaCode]').val('44')
        $('.code-txt_1f_F').html('+44')
      }
    })
    .catch((err) => {
      $('select[name=areaCode]').val('44')
      toast(err.message)
    })

  $('input[name=lastName]').blur(function () {
    sendEvent({
      eventId: 'en_Universal_LastNameInput',
      eventParam: {
        channel_code,
        channel_keyword,
        // lastname: $(this).val(),
        nation: ''
      }
    })
  }).val('')

  $('input[name=firstName]').blur(function () {
    sendEvent({
      eventId: 'en_Universal_NameInput',
      eventParam: {
        channel_code,
        channel_keyword,
        // name: $(this).val(),
        nation: ''
      }
    })
  }).val('')

  $('select[name=age]').on('change', function () {
    const valStr = $(this).val()
    submitFormData.age = valStr === 'Preschool' ? 5 : Number(valStr.split(' ')[0])

    sendEvent({
      eventId: 'en_Universal_AgeSelect',
      eventParam: {
        channel_code,
        channel_keyword,
        // grade: $(this).val(),
        nation: ''
      }
    })
  })

  $('select[name=subjectCode]').change(function () {
    submitFormData.subjectCode = $(this).val()

    sendEvent({
      eventId: 'en_Universal_SubjectSelect',
      eventParam: {
        channel_code,
        channel_keyword,
        // subject: $(this).val(),
        nation: ''
      }
    })
  })

  $('input[name=mobile]').blur(function () {
    sendEvent({
      eventId: 'en_Universal_PhoneInput',
      eventParam: {
        channel_code,
        channel_keyword,
        // phone: $(this).val(),
        nation: ''
      }
    })
  }).on('input', function () {
    const phoneVal = $(this).val()
    if (phoneVal !== '' && phoneRules.test(phoneVal) && !($('#authcodeButton').text().indexOf('s') > -1)) {
      $('#authcodeButton').removeAttr('disabled')
    } else {
      $('#authcodeButton').attr('disabled', 'disabled')
    }
  })

  $('input[name=email]').blur(function () {
    sendEvent({
      eventId: 'en_Universal_Email',
      eventParam: {
        channel_code,
        channel_keyword,
        // phone: $(this).val(),
        nation: ''
      }
    })
  })

  $('select[name=areaCode]').on('change', function () {
    sendEvent({
      eventId: 'en_Universal_AreaCodeSelect',
      eventParam: {
        channel_code,
        channel_keyword,
        nation: ''
      }
    })
    $('.code-txt_1f_F').html('+' + $(this).val())
  })

  $('.track-submit').click(function () {
    const index = $(this).attr('data-index')
    sendEvent({
      eventId: `en_Universal_ClickButton${index}`,
      eventParam: {
        channel_code,
        channel_keyword,
        nation: ''
      }
    })
  })

  $('.agreeClick').click(function () {
    sendEvent({
      eventId: 'en_Universal_UserAgreementClick',
      eventParam: {
        channel_code,
        channel_keyword,
        nation: ''
      }
    })
    setTimeout(() => {
      // window.location.href = "https://air-class.com/agreement/user?showCountry=0"
      window.location.href = 'https://air-class.com/agreement/user?showCountry=0'
    }, 300)
  })

  $('.policyClick').click(function () {
    sendEvent({
      eventId: 'en_Universal_PrivacyPolicyClick',
      eventParam: {
        channel_code,
        channel_keyword,
        nation: ''
      }
    })
    setTimeout(() => {
      // window.location.href = "https://air-class.com/agreement/user?showCountry=0"
      window.location.href = 'https://air-class.com/agreement/user?showCountry=0'
    }, 300)
  })

  // 文本框输入值记录
  $('input.txt').change(function (e) {
    const { key } = e.currentTarget.dataset
    submitFormData[key] = $(this).val()
  }).focus(function (e) {
    const placeholder = $(e.target).parent('.input_2jqT').find('.placeholder')[0] || $(e.target).siblings('.placeholder')[0]
    placeholder.style.display = 'none'
  }).blur(function (e) {
    const placeholder = $(e.target).parent('.input_2jqT').find('.placeholder')[0] || $(e.target).siblings('.placeholder')[0]
    placeholder.style.display = e.target.value.length > 0 ? 'none' : 'block'

    const key = $(this).attr('name')
    submitFormData[key] = $(this).val()
  })

  $('select.select').change(function (e) {
    $(e.target).siblings('.placeholder')[0].style.display = 'none'

    const key = $(this).attr('name')
    submitFormData[key] = $(this).val()
  })

  // 修改状态
  $('input[name=ucheck]').change(function () {
    if (this.checked) {
      sendEvent({
        eventId: 'en_Universal_Agreement',
        eventParam: {
          channel_code,
          channel_keyword,
          nation: 'en-UK'
        }
      })
    }
    submitFormData.checked = this.checked
  })

  let isShowFooterBar = false
  // 添加滚动监听
  window.addEventListener('scroll', (e) => {
    if (window.scrollY >= slideOffset.top - 100 && !isShowFooterBar) {
      $fixedFooterEle.addClass('show')
      isShowFooterBar = true
    }

    if (window.scrollY < slideOffset.top - 100 && isShowFooterBar) {
      isShowFooterBar = false
      $fixedFooterEle.removeClass('show')
    }
  })

  $fixedFooterEle.on('click', function () {
    $('.form-group').get(0).scrollIntoView({ behavior: 'smooth' })
    $(this).removeClass('show')
  })

  $('.track-submit').on('click', function () {
    $('.form-group').get(0).scrollIntoView({ behavior: 'smooth' })
    $(this).removeClass('show')
  })

  // 接口处理
  $('.submit-btn_3zbX').on('click', () => {
    const reportMsg = (result) => {
      sendEvent({
        eventId: 'en_Universal_SubmitResult',
        eventParam: {
          channel_code,
          channel_keyword,
          // result,
          nation: ''
        }
      })
    }
    const nameRules = /^[A-Za-z]*(\s[A-Za-z]*)*$/
    const emailRules = /^\w+([.-]\w+)*@\w+([.-]\w+)*\.\w+$/
    const LIMIT_TEN_LENGTH = 10
    const ENGLISH_AREAC_CODE = 44
    // 表单教研
    if (
      !submitFormData.firstName ||
      !submitFormData.lastName ||
      !nameRules.test(submitFormData.firstName) ||
      !nameRules.test(submitFormData.lastName)
    ) {
      toast('Errors in first name/last name')
      reportMsg('Errors in first name/last name')
      return
    }
    if (!submitFormData.age || !submitFormData.subjectCode) {
      toast('Please select age and subject')
      reportMsg('Please select age and subject')
      return
    }
    if (!submitFormData.mobile) {
      toast('Please fill in the phone number')
      reportMsg('Please fill in the phone number')
      return
    }
    if (submitFormData.mobile.length !== LIMIT_TEN_LENGTH && +areaCode === ENGLISH_AREAC_CODE) {
      toast('Incorrect number format')
      reportMsg('Incorrect number format')
      return
    }
    if (submitFormData.email !== '' && !emailRules.test(submitFormData.email)) {
      toast('Incorrect email format')
      reportMsg('Incorrect email format')
      return
    }
    if (smsCodeVision && submitFormData.smsCode === '') {
      toast('Please fill in the Verification code')
      reportMsg('Please fill in the Verification code')
      return
    }
    // policy
    if (!submitFormData.checked) {
      toast('Please read and consent to the User Agreement and Privacy Policy')
      reportMsg('Please read and consent to the User Agreement and Privacy Policy')
      return
    }
    sendEvent({
      eventId: 'en_Universal_SubmitResult',
      eventParam: {
        channel_code,
        channel_keyword,
        nation: ''
      }
    })
    const apiParam = Object.assign(submitFormData, {
      id: fetchId,
      name: submitFormData.firstName + ' ' + submitFormData.lastName,
      code: channel_code,
      key: channel_keyword,
      smsCodeType: 'UK',
      segmentCode: smsCodeVision ? 'appointmentWithCode' : 'appointmentWithoutCode',
      areaCode: $('select[name=areaCode]').val(),
      clickId,
      userAgent: navigator.userAgent
    })
    if (media_partner !== '') apiParam.mediaPartnerId = media_partner
    if (across_click_id !== '') apiParam.acrossClickId = across_click_id
    if (awc !== '') apiParam.awc = awc;
    fetchReserve(apiParam)
  })

  let isSubmit = false
  function fetchReserve(params) {
    if (isSubmit) return
    isSubmit = true
    return _api({
      url: `${newGateWay}/air/landing/page/air/appointment/${fetchId}/${languageId}`,
      method: 'POST',
      data: params
    })
      .then((res) => {
        isSubmit = false
        if (!res.appointmentId) return
        sendEvent({
          eventId: 'en_Universal_SuccessPageView',
          eventParam: {
            channel_code,
            channel_keyword,
            result: res.message || ''
          }
        })
        try {
          // awinTrack(res.appointmentId);
          gtag_report_conversion()
          fbq('track', 'Lead')
        } catch (err) {
          console.log(err)
          throw err
        } finally {
          window.location.href = '/en/landing/tutor/result/?channel_code=' + channel_code + '&channel_keyword=' + channel_keyword + '&from=applyTutor'
        }
      })
      .catch((err) => {
        isSubmit = false
      })
  }

  $('#authcodeButton').on('click', function sendVerificationCode() {
    sendEvent({
      eventId: 'EAF_20b070592655b86e',
      eventParam: {
        channel_code,
        channel_keyword
      }
    })
    const areaCode = $('select[name=areaCode]').val()
    if (submitFormData.mobile === '') {
      toast('Please enter phone number')
      return
    }
    let defaultCountNum = 59
    const btnTarget = this
    _api({
      url: `${newGateWay}/air/landing/page/air/appointment/${fetchId}/${languageId}`,
      method: 'POST',
      data: {
        id: fetchId,
        segmentCode: 'sendSmsCode',
        smsCodeType: 'UK',
        mobile: submitFormData.mobile,
        areaCode
      }
    })
      .then((res) => {
        toast('Your validation code has been sent')
        $(btnTarget).addClass('time-count').text(defaultCountNum + 's').attr('disabled', 'disabled')
        let countTimer = setInterval(function () {
          defaultCountNum -= 1
          if (defaultCountNum <= 0) {
            $(btnTarget).text('Get the code again').removeClass('time-count').removeAttr('disabled')
            clearInterval(countTimer)
            countTimer = null
            return
          }
          $('#authcodeButton').text(defaultCountNum + 's')
        }, 1000)
      })
  })

  function handleSubjectTemplate(data) {
    return data.reduce(
      (str, cur) => (str += '<option value="' + cur.subjectCode + '">' + cur.subjectName + '</option>'),
      '<option value="" disabled selected></option>'
    )
  }

  function handleAreaTemplate() {
    return Object.keys(countryCodeArr).reduce(
      (str, cur) =>
      (str +=
        '<option value="' +
        countryCodeArr[cur].code +
        '">' +
        countryCodeArr[cur].text +
        '</option>'),
      "<option style='display: none'></option>"
    )
  }
})
